/** @format **/

import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import GridContainer from '../../../components/Grid/GridContainer';
import { useDispatch } from 'react-redux';
import GridItem from '../../../components/Grid/GridItem';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles, Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { StorageReducerAction } from '../../../modules/storage/StorageReducers';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import { PlatformResellerCollectionInterface } from '../../../interfaces/collections/PlatformResellerCollectionInterface';
import MsisdnNotifyHistoryItem from './MsisdnNotifyHistoryItem';
import { PlusNotifyHelper } from '../../../helpers/PlusNotifyHelper';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import OplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

type MsisdnNotifyHistoryType = {
    classes: any;
    msisdn: PlatformMsisdnPoolNumber;
    platformResellerCollection: PlatformResellerCollectionInterface;
};

const defaultFiters = (msisdn: PlatformMsisdnPoolNumber): Array<Filter> => [{ name: 'msisdn', value: msisdn.msisdn.substr(2) }];
const defaultOrders = (): Array<Order> => [{ name: 'id', value: 'desc' }];

export const MsisdnNotifyHistory: FunctionComponent<MsisdnNotifyHistoryType> = ({
    classes,
    msisdn,
    platformResellerCollection,
}): React.ReactElement => {
    const [filters, setFilters] = useState<Array<Filter>>(defaultFiters(msisdn));
    const [orders, setOrders] = useState<Array<Order>>(defaultOrders());
    const dispatch = useDispatch();

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

    const updateOrderList = (newOrders: Array<Order>): void => setOrders(newOrders);
    const updateFilterList = (newFilters: Array<Filter>): void => setFilters(newFilters);

    const firstLoad = useCallback((): void => {
        dispatch({
            type: StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST,
            plusNotifyCollection: null,
        });
    }, [dispatch]);

    useEffect(() => {
        firstLoad();
    }, [dispatch, filters, orders, firstLoad]);

    return (
        <Card>
            <CardHeader trans="pools:msisdn.notify_history" />
            <CardBody>
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableControlStickyHeader} padding="none" align="right" style={{ paddingLeft: 0 }}>
                                <I18n trans="general:common.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prov:list.id"
                                    fieldName="id"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                            <React.Fragment>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        title="prov:list.partner"
                                        textAlign="center"
                                        fieldName="platformResellerId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerPlatformReseller"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={updateOrderList}
                                        updateFilterList={updateFilterList}
                                        searchActionCallback={firstLoad}
                                    />
                                </TableCell>
                            </React.Fragment>
                            {/*)}*/}
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="prov:list.notification_type"
                                    fieldName="typeGroupId"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="select"
                                    selectComponent="headerCheckBoxSimpleList"
                                    elementList={PlusNotifyHelper.notificationGroupTypesList()}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="prov:list.notification_direction"
                                    fieldName="notificationDirection"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="select"
                                    selectComponent="headerCheckBoxSimpleList"
                                    elementList={PlusNotifyHelper.notificationDirectionList()}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="prov:list.notification_description"
                                    fieldName="description"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="right"
                                    title="prov:list.event_date"
                                    fieldName="eventDate"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="date"
                                    dateFormat="RRRR-MM-DD"
                                    beforeSetToMax={true}
                                    afterSetToMin={true}
                                    dateFromTo={true}
                                    breakLine={true}
                                    timeFormat={false}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="right"
                                    title="prov:list.created_at"
                                    fieldName="createdAt"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="date"
                                    dateFormat="RRRR-MM-DD"
                                    beforeSetToMax={true}
                                    afterSetToMin={true}
                                    dateFromTo={true}
                                    breakLine={true}
                                    timeFormat={false}
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <MsisdnNotifyHistoryItem msisdn={msisdn} filters={filters} orders={orders} />
                </PaperedTable>
            </CardBody>
        </Card>
    );
};

export default withStyles(OplAppStyle)(MsisdnNotifyHistory);
